import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import TruckerDetails from './TruckerDetails';
import { Tab, Tabs, Row, Col } from 'react-bootstrap';
import Trash from "../../../assets/images/delete.svg";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import Select from 'react-select'
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faBoxArchive } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ADDTRUCKER, TRUCKERGRID, TRUCKERACTIVE, TRUCKERARCHIVE, TRUCKERTRASH, GETOWNERCODE, STATIONGRID } from '../../../Utils/conts.js';

const TruckerSettings = () => {

  const isMounted = useRef(false);
  const [disLoading, setDisLoading] = useState(false);
  const gridRef = useRef(null);
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
    Trash: useRef(null),
  };
  const [truckerData, setTruckerData] = useState({
    Active: [],
    Archived: [],
    Trash: []
  });

  // const [gridData, setTruckerData] = useState([{
  //     name: "aaaaaaaa",
  //     email: "444",
  //     number: "sdasadsad"
  // }]);
  const fetchDataGrid = async () => {
    setDisLoading(true)
    try {
      const res = await withRFSToken.post(TRUCKERGRID, { status: activeTab })
        .then(function (res) {
          const innerData = res.data.response_data;

          setTruckerData({ innerData });
        });
      setDisLoading(false)

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    if (isMounted.current) return;
    fetchDataGrid();
    isMounted.current = true;
  }, []);

  const [modalShow, setModalShow] = useState(false);
  const [modalPos, setModalPos] = useState('');
  const [reload, setReload] = useState(false);
  const [formData, setFormData] = useState({
    truckerName: '',
    truckerEmail: '',
    TruckerPhone: ''
  });

  const [activeTab, setActiveTab] = useState('Active');
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [gridSelect, setGridSelect] = useState([]);

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData);
  };
  const handleDetailsBackClick = (rowData) => {
    // setSelectedRowData(rowData);
    setShowDetails(false);
  };

  const handleAddButtonClick = (e) => {
    setModalPos(e)
    setModalShow(true);
    setFormData({});
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  // validation
  // const validateFormData = () => {
  //   let isValid = true;
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   // Function to validate email
  //   const validateEmail = (email) => {
  //     return emailRegex.test(email);
  //   };
  //   if (!formData.truckerName) {

  //     toast.error('Trucker Name must not be blank');
  //     isValid = false;
  //   } else
  //     if (!formData.TruckerPhone) {

  //       toast.error('Phone Number must not be blank');
  //       isValid = false;
  //     } else
  //       if (!/^\d{10}$/.test(formData.TruckerPhone)) {

  //         toast.error('Phone Number must be 10 Digits');
  //         isValid = false;
  //       } else
  //         if (!formData.truckerEmail) {

  //           toast.error('Email must not be blank');
  //           isValid = false;
  //         } else if (!validateEmail(formData.truckerEmail)) {

  //           toast.error('Invalid email address');
  //           isValid = false;
  //         }
  //         else {
  //           return isValid;
  //         }
  // };
  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateEmail = (email) => emailRegex.test(email);

    // ✅ Trucker Name - always required
    if (!formData.truckerName?.trim()) {
      toast.error('Trucker Name must not be blank');
      isValid = false;
    }

    // ✅ Phone - optional, but must be 10 digits if entered
    else if (formData.TruckerPhone && !/^\d{10}$/.test(formData.TruckerPhone)) {
      toast.error('Phone Number must be 10 Digits');
      isValid = false;
    }

    // ✅ Email - optional, but must be valid if entered
    else if (formData.truckerEmail && !validateEmail(formData.truckerEmail)) {
      toast.error('Invalid email address');
      isValid = false;
    }

    return isValid;
  };
  const handleAddCarrier = async () => {
    if (validateFormData()) {
      const newData = {
        TruckerName: formData.truckerName,
        TruckerEmail: formData.truckerEmail,
        TruckerPhone: formData.TruckerPhone
      };

      try {
        const res = await withRFSToken.post(ADDTRUCKER, formData)
          .then(function (res) {
            // const innerData = res;
            //
            if (res.data.response_code == 200) {
              setTruckerData(res.data.response_data)
              toast.success('Trucker Added Successfully')
              reloadGrid(activeTab);
              setReload(prev => !prev);
            }
          });

      } catch (error) {
        console.error('Error sending request:', error);
      }

      // setTruckerData(prevData => [...prevData, newData]);
      // localStorage.setItem('truckerData', JSON.stringify([...truckerData, newData]));

      setFormData({
        truckerName: '',
        truckerEmail: '',
        TruckerPhone: ''
      });
      setModalShow(false);
    }
  };

  // useEffect(() => {
  //   localStorage.setItem('truckerData', JSON.stringify(truckerData));
  // }, [truckerData]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    reloadGrid(tab);
    setGridSelect([]);
  };

  let checkUlds = [];
  useEffect(() => {
    if (gridRefs[activeTab] && !showDetails) {
      const localData = truckerData;
      // && truckerData.map(item => ({
      //     TruckerName: item.TruckerName,
      //     TruckerEmail: item.TruckerEmail,
      //     TruckerPhone: item.TruckerPhone,

      // }));

      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'trucker_id', type: 'string' },
          { name: 'trucker_request_emails', type: 'string' },
          { name: 'trucker_name', type: 'string' },
          { name: 'trucker_email', type: 'string' },
          { name: 'trucker_phone', type: 'string' },
        ],
        localdata: localData,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        { text: 'Trucker Name', filtertype: 'input', datafield: 'trucker_name', width: '31%' },
        { text: 'Email', filtertype: 'input', datafield: 'trucker_email', width: '31%' },
        { text: 'Phone Number', filtertype: 'input', datafield: 'trucker_phone', width: '31%' },
      ];

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: false,
        pageSize: 10,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 40,
        showfilterrow: true,
        rowsheight: 42,
      };

      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRefs[activeTab].current).on('rowclick', (event) => {

        const args = event.args.row.bounddata;

        setSelectedRowData(event);
        setShowDetails(true);
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.trucker_id;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.trucker_id === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.trucker_id === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.trucker_id;
          setGridSelect(prevSelection => prevSelection.filter(row => row.trucker_id !== unselectedRowId));
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });

      // window.$(gridRefs[activeTab].current).on('rowselect', (event) => {


      //   if (event.args.row) {

      //     const selectedRow = event.args.row.id;


      //     if (!gridSelect.includes(selectedRow)) {
      //       setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
      //     }
      //     // setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
      //   } else {
      //     // Handle "Select All" case
      //     // const allIds = planData.map(row => row.booking_id);
      //     //
      //     // setGridSelect(allIds);

      //   }
      // });
      // //
      // window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
      //   if (event.args.row) {
      //     const unselectedRowId = event.args.row.id;
      //     setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
      //   } else {
      //     setGridSelect([]);
      //   }
      // });
    }
  }, [truckerData, showDetails]);

  const handleArchiveButtonClick = () => {
    archiveSelectedRows(gridSelect);
  };
  const archiveSelectedRows = async (selectedIds) => {
    const uniqueIds = Array.from(new Set(selectedIds.map(item => item.trucker_id)));
    if (selectedIds.length > 0) {
      try {
        const response = await withRFSToken.post(TRUCKERARCHIVE, { trucker_ids: uniqueIds });
        if (response.data.response_code == 200) {
          toast.success(response.data.response_msg)
        }
        // dispatch(addDataSuccess(data));
        // dispatch(fetchStationGridData());
        reloadGrid(activeTab);
      } catch (error) {
        // dispatch(addDataFailure(error.message));
        console.error('Error fetching data:', error);
      }
    } else {
      toast.error('Select At least one row.')
    }
    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
    // dispatch(fetchStationGridData());
    reloadGrid();
  };

  const handleActiveButtonClick = () => {
    activeSelectedRows(gridSelect);
  };
  const activeSelectedRows = async (selectedIds) => {
    const uniqueIds = Array.from(new Set(selectedIds.map(item => item.trucker_id)));
    if (selectedIds.length > 0) {
      try {
        const response = await withRFSToken.post(TRUCKERACTIVE, { trucker_ids: uniqueIds });
        if (response.data.response_code == 200) {
          toast.success(response.data.response_msg)
        }
        reloadGrid(activeTab);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
    reloadGrid(activeTab);
  };

  const handleDeleteButtonClick = () => {
    deleteSelectedRows(gridSelect);
    // if (gridSelect){
    //   handleShowConfirmation(deleteSelectedRows);
    // }
  };
  const deleteSelectedRows = async (selectedIds) => {
    // Perform deletion logic here using the selected IDs

    const uniqueIds = Array.from(new Set(selectedIds.map(item => item.trucker_id)));
    // Now you can send the selected IDs to your API or perform any other action
    if (selectedIds.length > 0) {
      // dispatch(addStationRemoveData(selectedIds)); // Pass sendStationData to addData thunk
      try {
        const response = await withRFSToken.post(TRUCKERTRASH, { trucker_ids: uniqueIds });

        if (response.data.response_code == 200) {
          toast.success(response.data.response_msg)
        }
        reloadGrid();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
    // dispatch(fetchStationGridData());
    reloadGrid(activeTab);
  };


  const reloadGrid = async (tab) => {
    try {
      const res = await withRFSToken.post(TRUCKERGRID, { status: tab })
        .then(function (res) {
          const innerData = res.data.response_data;
          setTruckerData(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleEditClick = (data) => {

    setModalPos(data.position)
    const { position, ...rest } = data;
    setModalShow(true);
    setFormData(rest);
  };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {disLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
      {/* <div className="">
        <Header logo_url={SBack ? SBack : '/BookingtruckSchedule'} sBackUrl={SBack ? SBack : '/BookingtruckSchedule'} />
        <div className="main-panel">
          <div className="row">
            <LeftSettings /> */}
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          {!showDetails &&
            <>
              <h4>Trucker Settings</h4>
              <p>Add Carrier</p>

              <div className='row'>

                <div className='col-6'>

                  <div>
                    <Button variant="primary createplan" onClick={() => handleAddButtonClick('at')}>
                      <FontAwesomeIcon icon={faPlus} /> Add Trucker
                    </Button>
                  </div>
                  <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="station_grid">
                    <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                      <div className='moveto_btn'>
                        <button onClick={handleArchiveButtonClick}> <img src={Arcv} /></button>
                        <button onClick={handleDeleteButtonClick}><img src={Trash} /></button>
                      </div>
                      <div ref={gridRefs.Active} className='staion_grid' ></div>
                    </Tab>
                    <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                      <div className='moveto_btn'>
                        <button onClick={handleActiveButtonClick}> <img title='' src={Active} /></button>
                        <button onClick={handleDeleteButtonClick}><img src={Trash} /></button>
                      </div>
                      <div ref={gridRefs.Archived} className='staion_grid' ></div>
                    </Tab>
                    <Tab eventKey="Trash" title={<span>Trash</span>} className='moveto'>
                      <div className='moveto_btn'>
                        <button onClick={handleActiveButtonClick}> <img src={Active} /></button>
                      </div>
                      <div ref={gridRefs.Trash} className='staion_grid' ></div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </>
          }

          <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
            <Modal.Header closeButton>
              <Modal.Title>Add {modalPos === 'at' ? 'Trucker' : 'Truck Schedule'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Trucker Name</Form.Label>
                <Form.Control type="text" placeholder="Trucker Name" name='truckerName' value={formData.truckerName} onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Telephone No</Form.Label>
                <Form.Control type="number" placeholder="Enter Telephone No" maxLength='10' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }} name='TruckerPhone' value={formData.TruckerPhone} onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Email ID</Form.Label>
                <Form.Control type="email" placeholder="Enter Email ID" name='truckerEmail' value={formData.truckerEmail} onChange={handleChange} />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleAddCarrier}>Add Trucker</Button>
            </Modal.Footer>
          </Modal>

          {showDetails && (
            <>
              <button className='backbtn' onClick={handleDetailsBackClick}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
              <TruckerDetails rowData={selectedRowData} reload={fetchDataGrid} dload={reload} onEdit={handleEditClick} />
            </>
          )}
        </div>
      </div>
      {/* </div>
        </div>
      </div> */}
    </>
  )
}

export default TruckerSettings;